export default "__VITE_ASSET__zz8beVld__"